export const formatEtaFromDate = (epochDate: number, inMs: boolean = false): { value: number, text: string } => {
    let now = inMs ? new Date().valueOf() : new Date().valueOf() / 1000;
    let diff: number = now - epochDate;
    let result: { value: number, text: string };
    if (diff < 60) result = { value: null, text: 'shared.justNow' };
    else if (diff < 3600) result = { value: Math.round(diff / 60), text: 'shared.minsAgo' }
    else if (diff < 86400) result = { value: Math.round(diff / 3600), text: 'shared.hoursAgo' }
    else if (diff < 2592000) result = { value: Math.round(diff / 86400), text: 'shared.daysAgo' }
    else result = { value: Math.round(diff / 2592000), text: 'shared.monthsAgo' }
    return result;
}

export const formatSecondsForCuntDown = (epochDate: number): { days: number, hours: number, minutes: number, seconds: number } => {
    let days, hours, minutes, seconds;
    days = (Math.floor(epochDate / 86400)).toFixed(0);
    epochDate -= days * 86400;
    hours = (Math.floor(epochDate / 3600) % 24).toFixed(0);
    epochDate -= hours * 3600;
    minutes = (Math.floor(epochDate / 60) % 60).toFixed(0);
    epochDate -= minutes * 60;
    seconds = (epochDate % 60).toFixed(0);

    return {
        days,
        hours,
        minutes,
        seconds
    };
}

export const formatMillSecondsForAge = (epochDate: number, referenceDate: Date = new Date()): IAge => {
    const millisecondsDifference = referenceDate.getTime() - epochDate;
    const secondsDifference = Math.floor(millisecondsDifference / 1000);

    let year = 0, month = 0, day = 0, hour = 0, minute = 0, second = 0;

    second = secondsDifference % 60;
    const minutesDifference = Math.floor(secondsDifference / 60);
    minute = minutesDifference % 60;
    const hoursDifference = Math.floor(minutesDifference / 60);
    hour = hoursDifference % 24;
    const daysDifference = Math.floor(hoursDifference / 24);
    day = daysDifference % 30; // Assuming a month is 30 days for simplicity
    month = Math.floor(daysDifference / 30);
    year = Math.floor(month / 12);
    month = month % 12;

    return {
        year,
        month,
        day,
        hour,
        minute,
        second
    };
}

export interface IAge {
    year: number
    month: number
    day: number
    hour: number
    minute: number
    second: number
}
